export const UserTypes: any = {
  Staff: 1,
  Scheduler: 2,
  HubUser: 9,
  ExternalFacilityUser: 12
};
